<div class="conf-lob-selection-title">
    <div class="conf-inner-title">

      <div class="conf-sec-1">
        <div class="conf-lob-title" (click)="routeToHome()">
          <div class="conf-back-arrow">
              <img src="{{confAWSUrlStr}}/common/arrow-back.svg" alt="back-btn">
              <span class="conf-btn-desk">Back to Home</span>
              <span class="conf-btn-mob"> Home</span>
          </div>

        </div>
      </div>

      <div class="conf-sec-2">
        <!-- <p class="conf-navHeaderTitle" (click)="routeToOSP()">Online Sales Platform</p> -->
        <img src="{{confAWSUrlStr}}/common/tml_logo_new.svg" class="conf-navHeaderTitle" (click)="routeToTml()"  style="padding: 5px;">
        <span  class="conf-ver-line"></span>
        <!-- <img class="conf-tml-logo" (click)="routeToTml()" src="{{confAWSUrlStr}}/common/tml_logo.svg"> -->
        <img class="conf-tml-logo" (click)="routeToOSP()" src="{{confAWSUrlStr}}/common/fleetverse_logo_solid_wide.svg">
        <span  class="conf-ver-line"></span>
        <p class="conf-navHeaderTitle">{{navHeaderTitle}}</p>
      </div>

      <div class="conf-sec-3">
        <ng-container *ngIf="showGroupIcons">
          <div class="conf-btn-group">
            <!-- <div class="conf-share-btn conf-gr-btn">
              <img src="{{confAWSUrlStr}}/common/share-btn-icon.png" alt="conf-share">
            </div> -->
            <div class="conf-like-btn conf-gr-btn" (click)="addToWishlist()">
              <img src="{{confAWSUrlStr}}/common/like.png" alt="conf-like">
            </div>
            <!-- <div class="conf-download-btn conf-gr-btn" [ngClass]="disableBtn ? 'conf-btnDisable' : ''" (click)="download()">
              <img src="{{downloadIcon}}" alt="conf-download">
            </div> -->
          </div>
        </ng-container>

        <div class="conf-save-option">
          <span  class="conf-btn-desk" (click)="saveSelections()">Save Your Build</span>
          <span  class="conf-btn-mob" (click)="saveSelections()">Save</span>
        </div>
      </div>

    </div>
</div>


<div class="modal conf-modal" tabindex="-1" role="dialog" data-backdrop="static" *ngIf="showSaveModalStatus" >
    <div class="modal-dialog conf-modal-dialog" role="document">
      <div class="modal-content conf-modal-content">
        <div class="conf-modal-content-img-div">
            <img class="conf-modal-content-img" src="{{confAWSUrlStr}}/common/warning_icon.svg">
        </div>
        <div class="modal-header conf-modal-header">
          <h5 class="modal-title conf-modal-title">Save Configuration</h5>
        </div>
        <div class="modal-body conf-modal-body">
          <p>Are you sure you want to save all selections?</p>
        </div>
        <div class="modal-footer conf-modal-footer">
          <button type="button" class="btn btn-secondary conf-btn-cancel" (click)="showSaveModalStatus=false">Cancel</button>
          <button type="button" class="btn btn-primary conf-btn-yes" (click)="saveConfSelection()">Save</button>
        </div>
      </div>
    </div>
  </div>
